import type { ReactElement } from "react";
import "./SourcePreview.css";

interface Props {
    text: string;
    icon?: ReactElement;
}

export const SourcePreviewTitle = ({ text, icon }: Props) => {
    return (
        <p className="wai-source-card-title">
            {icon}
            <span>{text}</span>
        </p>
    );
};
